import moment from "moment";
import React from "react";

const statusBadge = (status) => {
  if (!status) return null;
  const s = status?.toUpperCase();
  let bg = "#F3F4F6";
  let color = "#374151";
  if (s === "DISETUJUI" || s === "APPROVED" || s === "TEPAT") { bg = "#D1FAE5"; color = "#065F46"; }
  else if (s === "DITOLAK" || s === "REJECTED") { bg = "#FEE2E2"; color = "#991B1B"; }
  else if (s === "MENUNGGU" || s === "PENDING") { bg = "#FEF3C7"; color = "#92400E"; }
  else if (s === "TELAT") { bg = "#FEE2E2"; color = "#991B1B"; }
  return (
    <span className="text-xs font-semibold rounded-full px-2.5 py-1" style={{ backgroundColor: bg, color }}>
      {status}
    </span>
  );
};

const Lists = ({ riwayatpresensi, riwayatizin, riwayatdinas, text, text2, text3, text4, text5, onClick }) => {
  if (riwayatpresensi) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 mt-3">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-bold text-gray-800">
            {moment(text).format("DD MMM YYYY")}
          </span>
          <svg className="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div className="flex gap-3">
          <div className="flex-1 bg-green-50 rounded-xl px-3 py-2">
            <p className="text-xs text-gray-500 mb-0.5">Masuk</p>
            <p className="text-sm font-bold text-gray-800">{text2}</p>
            <div className="mt-1">{statusBadge(text3)}</div>
          </div>
          <div className="flex-1 bg-orange-50 rounded-xl px-3 py-2">
            <p className="text-xs text-gray-500 mb-0.5">Pulang</p>
            <p className="text-sm font-bold text-gray-800">{text4}</p>
            <div className="mt-1">{statusBadge(text5)}</div>
          </div>
        </div>
      </div>
    );
  }

  if (riwayatizin) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 mt-3">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-xs text-gray-400 mb-0.5">Jenis Izin</p>
            <p className="text-sm font-bold text-gray-800">{text}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-400 mb-0.5">Tanggal</p>
            <p className="text-sm font-semibold text-gray-700">{moment(text2).format("DD MMM YYYY")}</p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          {statusBadge(text3)}
        </div>
      </div>
    );
  }

  if (riwayatdinas) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 mt-3">
        <div className="flex items-start justify-between mb-2">
          <div>
            <p className="text-xs text-gray-400 mb-0.5">Tanggal</p>
            <p className="text-sm font-bold text-gray-800">{moment(text).format("DD MMM YYYY")}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-400 mb-0.5">Durasi</p>
            <p className="text-sm font-semibold text-gray-700">{text4} Hari</p>
          </div>
        </div>
        {text2 && (
          <p className="text-xs text-gray-500 mb-2 bg-gray-50 rounded-lg px-3 py-1.5">{text2}</p>
        )}
        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
          {statusBadge(text3)}
          <button
            onClick={onClick}
            className="text-xs font-semibold flex items-center gap-1 px-3 py-1.5 rounded-lg transition"
            style={{ color: "#FFB703", backgroundColor: "#FFF3CD" }}
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            Lihat Bukti
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default Lists;
